import React from 'react';
import driveDayDiary from '../../assets/images/drive-day-diary.png';
import travelImg from '../../assets/images/travel5.png';
import shapeTwo from '../../assets/images/shape/shape-2.png';
import shapeThree from '../../assets/images/shape/shape-3.png';
import shapeFour from '../../assets/images/shape/shape-4.png';
import { IOS_APP_URL, ANDROID_APP_URL } from '../../storeLinks';

function HeroHomeOne({ className }) {
    return (
        <>
            <section className={`dd-hero-area ${className || ''}`}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="dd-hero-content">
                                {/* <span>Manage your driving instructor business</span> */}
                                <h1 className="dd-title">
                                    Diary & business management for driving instructors & schools
                                </h1>
                                <p>
                                    {/* Rethinking diary management for the instructor */}
                                    Optional pupil app included
                                </p>
                                <ul>
                                    <li>
                                        <a href={IOS_APP_URL}>
                                            <i className="fab fa-apple" /> Download for iOS
                                        </a>
                                    </li>
                                    <li>
                                        <a className="item-2" href={ANDROID_APP_URL}>
                                            <i className="fab fa-google-play" /> Download for
                                            Android
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="dd-hero-thumb">
                                <div
                                    className="thumb wow animated fadeInUp"
                                    data-wow-duration="2000ms"
                                    data-wow-delay="200ms"
                                >
                                    <div className="dd-phone">
                                        <img
                                            className="dd-phone-screen"
                                            src={driveDayDiary}
                                            alt="Drive.Day diary week view"
                                        />
                                        <img
                                            className="dd-phone-zoom"
                                            src={travelImg}
                                            alt="Close-up: 12 mins late, travel time"
                                        />
                                        <div className="dd-phone-card">
                                            <span className="dd-phone-card-icon">
                                                <i className="fa-jelly-fill fa-regular fa-car" />
                                            </span>
                                            <span>Travel time built right into your diary</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="hero-shape-1">
                    <img src={shapeTwo} alt="" />
                </div>
                <div className="hero-shape-2">
                    <img src={shapeThree} alt="" />
                </div>
                <div className="hero-shape-3">
                    <img src={shapeFour} alt="" />
                </div>
            </section>
        </>
    );
}

export default HeroHomeOne;
